"use strict";

//Language
var url = window.location.href;
if (url.indexOf("/en/") !== -1) {
  var lang = "en";
} else {
  var lang = "de";
}

var Doptions = [6, 8, 10, 12, 14, 16, 18, 20, 22, 26, 30, 34, 40];

// colors
let greena = "rgba(200,255,200,0.7)";
let green9 = "rgba(200,255,200,0.2)";
let blue9 = "rgba(200,200,255,0.2)";

//Arrows
let arrow_head_length = 0.4; // value manually extracted from on draw.lib
let arrow_head_length_scale = 30;
let gap = 10;
let arrowlength;

// plot width
let w = 200;

// Model Parameters

// Reinforcement
var Reinforcement = {
  steelTypes: [
    { name: "B500A", fsk: 500, ks: 1.05, epsUk: 0.025 },
    { name: "B500B", fsk: 500, ks: 1.08, epsUk: 0.05 },
    { name: "B500C", fsk: 500, ks: 1.25, epsUk: 0.075 },
    { name: "B700B", fsk: 700, ks: 1.08, epsUk: 0.05 },
  ],
  es: 205,
};

var x = [0, -1];
var y = [0, 4];
var i = 0;

var N_marker = 0;
var Lambda = 1;

var init = 0;

var rType = parseFloat($("#conType").val());
var Es = Reinforcement.es * 1000;
var fsy = Reinforcement.steelTypes[rType].fsk;
var fsu =
  Reinforcement.steelTypes[rType].fsk * Reinforcement.steelTypes[rType].ks;
var esu = Reinforcement.steelTypes[rType].epsUk;
$("#refFsy").html(fsy);
$("#refks").html(Reinforcement.steelTypes[rType].ks);
$("#refFsu").html(fsu);
$("#refEsu").html(esu * 1000);
$("#Es").html(Es / 1000);

var bType = parseFloat($("#bondType").val());

var D = Doptions[parseFloat($("#D").val())];

var cType = parseFloat($("#conType").val());

var fct = Mat.Concrete.types[cType].fctm;

let Ec = 10000 * Math.pow(Mat.Concrete.types[cType].fcm, 1 / 3);

let minrho = fct / (fsu - fct * (Es / Ec - 1)) + 0.000001;

$("#conFct").html(fct);
$("#conEc").html(math.round(Ec) / 1000);

var Ac = parseFloat($("#ac").val()); // [mm2]

var esy = fsy / Es;
var Esh = (fsu - fsy) / (esu - esy);
var taub0 = 2 * fct;
var taub1 = fct;

$("#Taub0").html(taub0);
$("#Taub1").html(taub1);

var rho = parseFloat($("#rho").val()) / 100;
var srm;

// Plot Parameters
var domain_l = 0.05;
var domain_r = 0.95;

var he = 550; //px
var we = 150; //px

var range_esm_init;
var range_N_init;
var range_wr_init;

var range_sigma_c_init;
var range_sigma_s_init;
var range_eps_c_init;
var range_eps_s_init;
var range_u_c_init;
var range_u_s_init;
var range_tau_init;

updateranges();

var range_y_init = [-300, 300];
var range_y_default = range_y_init;
var currentyRangeTCElement = range_y_init;

var wr_magnification;
var w_r_marker;

var plotElement = document.getElementById("plotElement");
let tempSec;

// Load Carousel
$(document).ready(function () {
  $("#N_Carousel").slick({
    prevArrow: "#N_CarouselPrev",
    nextArrow: "#N_CarouselNext",
    appendDots: "#N_CarouselNav",
    dots: true,
    draggable: false,
  });
});
$(document).ready(function () {
  $("#TC_Carousel").slick({
    prevArrow: "#TC_CarouselPrev",
    nextArrow: "#TC_CarouselNext",
    appendDots: "#TC_CarouselNav",
    dots: true,
    draggable: false,
  });
});

$("#formN").attr("max", Math.round(fsu * Ac * rho) / 1000);

$(".nav-tabs a").on("shown.bs.tab", function (event) {
  MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#CtrlMx"]);
});

var xsld1 = document.getElementById("sliderN");
noUiSlider.create(xsld1, {
  start: [0],
  range: {
    min: 0,
    max: Math.round(fsu * Ac * rho) / 1000,
  },
  tooltips: false,
  step: 0.001,
  pips: {
    mode: "count",
    values: 11,
    density: 10,
  },
  format: {
    to: function (value) {
      return Math.round(value * 1000) / 1000;
    },
    from: function (value) {
      return value;
    },
  },
});
xsld1.noUiSlider.on("change", function () {
  updateN();
});

xsld1.noUiSlider.on("slide", function () {
  if (xsld1.noUiSlider.get() == Math.round(fsu * Ac * rho) / 1000) {
    setTimeout(function () {
      $("#formN").val((fsu * Ac * rho) / 1000);
    }, 1);
    N_marker = Ac * rho * fsu;
  } else {
    N_marker = xsld1.noUiSlider.get() * 1000;
    $("#formN").val(xsld1.noUiSlider.get());
  }
});

$("#formN").change(function () {
  N_marker = parseFloat($("#formN").val()) * 1000;
  if (N_marker / 1000 == Math.round(fsu * Ac * rho) / 1000) {
    N_marker = Ac * rho * fsu;

    setTimeout(function () {
      $("#formN").val((fsu * Ac * rho) / 1000);
    }, 1);
  } else {
    // $("#formN").attr("data-decimals", 2);
    // $("#formN").val(N_marker/1000);
  }

  xsld1.noUiSlider.set(N_marker / 1000);
  updateN();
});

$("#formN").on("input", function (event) {
  // $("#formN").attr("data-decimals", 2);
});

var xsld2 = document.getElementById("sliderLambda");
noUiSlider.create(xsld2, {
  start: [1],
  tooltips: true,
  range: {
    min: 0.5,
    max: 1,
  },

  step: 0.01,
  pips: {
    mode: "count",
    values: 6,
    density: 20,
    format: {
      to: function (value) {
        return Math.round(value * 100) / 100;
      },
      from: function (value) {
        return value;
      },
    },
  },
});
xsld2.noUiSlider.on("change", updateLambda);

function updateN() {
  document.getElementById("sliderN").setAttribute("disabled", true);
  setTimeout(
    "document.getElementById('" +
      "sliderN" +
      "').removeAttribute('" +
      "disabled" +
      "');",
    500
  );

  updateCalc();
}
function updateLambda(values, handle, unencoded, tap, positions) {
  document.getElementById("sliderLambda").setAttribute("disabled", true);
  setTimeout(
    "document.getElementById('" +
      "sliderLambda" +
      "').removeAttribute('" +
      "disabled" +
      "');",
    500
  );
  Lambda = values[0];
  updateCalc();
}

$("#rho").on("change", function (event) {
  document.getElementById(this.id).disabled = true;
  setTimeout("document.getElementById('" + this.id + "').disabled=false;", 500);
  var rho_old = rho;
  rho = parseFloat($("#rho").val()) / 100;
  minrho = fct / (fsu - fct * (Es / Ec - 1)) + 0.000001;
  if (rho < minrho) {
    rho = minrho;
    $("#rho").val(rho * 100);
    document.getElementById("rho").classList.add("is-invalid");
    document.getElementById("Ctrl").classList.add("focus");

    let alertmsg =
      "Der Bewehrungsgehalt ist zu klein und führt zu einem spröden Versagen des Zuggurts (Stichwort: Mindestbewehrung).<br><br>Der Wert wurde auf ρ=fct/(fsu-fct*(n-1))=" +
      math.round(minrho * 100000) / 1000 +
      "% gesetzt, sodass die Bewehrung beim Reissen des Elements gerade nicht bricht.";

    if (lang == "en") {
      alertmsg =
        "The reinforcement content is too small and leads to a brittle failure of the tension chord (keyword: minimum reinforcement).<br><br>The value was set to ρ=fct/(fsu-fct*(n-1))=" +
        math.round(minrho * 100000) / 1000 +
        "% so that the reinforcement just does not rupture when the element cracks.";
    }

    bootbox.alert({
      size: "large",
      message: alertmsg,
      callback: function () {
        setTimeout(function () {
          document.getElementById("rho").classList.remove("is-invalid");
          document.getElementById("Ctrl").classList.remove("focus");
        }, 500);
      },
    });
  } else if (isNaN(rho)) {
    rho = rho_old;
    $("#rho").val(rho * 100);
    document.getElementById("rho").classList.add("is-invalid");
    document.getElementById("Ctrl").classList.add("focus");

    let alertmsg = "Die Eingabe ist keine Zahl.";
    if (lang == "en") {
      alertmsg = "The input is not a number.";
    }
    bootbox.alert({
      message: alertmsg,
      callback: function () {
        setTimeout(function () {
          document.getElementById("rho").classList.remove("is-invalid");
          document.getElementById("Ctrl").classList.remove("focus");
        }, 500);
      },
    });
  }

  Ac = parseFloat($("#ac").val());

  var slidervalue = parseFloat(sliderN.noUiSlider.get());
  sliderN.noUiSlider.updateOptions({
    range: {
      min: 0,
      max: Math.round(fsu * Ac * rho) / 1000,
    },
  });

  sliderN.noUiSlider.set(math.min(slidervalue, (Ac * rho * fsu) / 1000));
  N_marker = math.min(slidervalue * 1000, Ac * rho * fsu);
  if (math.round(N_marker) == math.round(Ac * rho * fsu)) {
    N_marker = Ac * rho * fsu;
  }

  $("#formN").val(math.min(slidervalue, (Ac * rho * fsu) / 1000));
  $("#formN").attr("max", Math.round(fsu * Ac * rho) / 1000);
  updateCalc();
});

$("#ac").change(function () {
  document.getElementById(this.id).disabled = true;
  setTimeout("document.getElementById('" + this.id + "').disabled=false;", 500);

  var Ac_old = Ac;
  Ac = parseFloat($("#ac").val());

  if (isNaN(Ac)) {
    Ac = Ac_old;
    $("#ac").val(Ac);
    document.getElementById("ac").classList.add("is-invalid");
    document.getElementById("Ctrl").classList.add("focus");

    bootbox.alert({
      message: "Die Eingabe ist keine Zahl.",
      callback: function () {
        setTimeout(function () {
          document.getElementById("ac").classList.remove("is-invalid");
          document.getElementById("Ctrl").classList.remove("focus");
        }, 500);
      },
    });
  }
  var slidervalue = parseFloat(sliderN.noUiSlider.get());
  sliderN.noUiSlider.updateOptions({
    range: {
      min: 0,
      max: Math.round(fsu * Ac * rho) / 1000,
    },
  });
  sliderN.noUiSlider.set(math.min(slidervalue, (Ac * rho * fsu) / 1000));
  N_marker = math.min(slidervalue * 1000, Ac * rho * fsu);
  if (math.round(N_marker) == math.round(Ac * rho * fsu)) {
    N_marker = Ac * rho * fsu;
  }
  $("#formN").val(math.min(slidervalue, (Ac * rho * fsu) / 1000));
  $("#formN").attr("max", Math.round(fsu * Ac * rho) / 1000);
  updateCalc();
});
$("#D").change(function () {
  D = Doptions[parseFloat($("#D").val())];
});

$("#conType").change(function () {
  cType = parseFloat($("#conType").val());
  if (cType < 6) {
    fct = Mat.Concrete.types[cType].fctm;

    Ec = 10000 * Math.pow(Mat.Concrete.types[cType].fcm, 1 / 3);

    $("#conFct").html(fct);
    $("#conEc").html(math.round(Ec) / 1000);

    if (parseFloat($("#bondType").val()) == 0) {
      taub0 = 2 * fct;
      taub1 = fct;
      $("#Taub0").html(taub0);
      $("#Taub1").html(taub1);
    }

    checkminrho();

    updateCalc();
  }
});
$("#refType").change(function () {
  rType = parseFloat($("#refType").val());

  if (rType < 4) {
    Es = Reinforcement.es * 1000;
    fsy = Reinforcement.steelTypes[rType].fsk;
    fsu =
      Reinforcement.steelTypes[rType].fsk * Reinforcement.steelTypes[rType].ks;
    esu = Reinforcement.steelTypes[rType].epsUk;
    $("#refFsy").html(fsy);
    $("#refks").html(Reinforcement.steelTypes[rType].ks);
    $("#refFsu").html(fsu);
    $("#refEsu").html(esu * 1000);
    $("#Es").html(Es / 1000);

    esy = fsy / Es;
    Esh = (fsu - fsy) / (esu - esy);

    Ac = parseFloat($("#ac").val());
    rho = parseFloat($("#rho").val()) / 100;

    checkminrho();

    updateCalc();
  }
});

$("#bondType").change(function () {
  if (parseFloat($("#bondType").val()) == 0) {
    taub0 = 2 * fct;
    taub1 = fct;
    $("#Taub0").html(taub0);
    $("#Taub1").html(taub1);

    $("#Taub0formula").html("$\\tau_{b0}=2f_{ctm}$");
    MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#Taub0formula"]);
    $("#Taub1formula").html("$\\tau_{b1}=f_{ctm}$");
    MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#Taub1formula"]);
  } else {
    $("#Taub0formula").html("$\\tau_{b0}$");
    MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#Taub0formula"]);
    $("#Taub1formula").html("$\\tau_{b1}$");
    MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#Taub1formula"]);
  }

  updateCalc();
});

$("#wr_magnification").change(function () {
  document.getElementById(this.id).disabled = true;
  setTimeout("document.getElementById('" + this.id + "').disabled=false;", 500);
  var wr_magnification_old = wr_magnification;
  wr_magnification = parseFloat($("#wr_magnification").val());

  if (isNaN(wr_magnification)) {
    wr_magnification = wr_magnification_old;

    $("#wr_magnification").val(wr_magnification);
    document.getElementById("wr_magnification").classList.add("is-invalid");
    document.getElementById("Ctrl").classList.add("focus");

    bootbox.alert({
      message: "Die Eingabe ist keine Zahl.",
      callback: function () {
        setTimeout(function () {
          document
            .getElementById("wr_magnification")
            .classList.remove("is-invalid");
          document.getElementById("Ctrl").classList.remove("focus");
        }, 500);
      },
    });

    return;
  }
  updateCalc();
});

$(".updCalc").change(function () {
  updateCalc();
});

// editable table
$(document).ready(function () {
  // concrete

  $("#conFct").keypress(function (e) {
    if (e.keyCode == 13) {
      this.blur();
    }
  });
  $("#conEc").keypress(function (e) {
    if (e.keyCode == 13) {
      this.blur();
    }
  });

  // steel
  $("#refFsy").keypress(function (e) {
    if (e.keyCode == 13) {
      this.blur();
    }
  });
  $("#refFsu").keypress(function (e) {
    if (e.keyCode == 13) {
      this.blur();
    }
  });
  $("#refEsu").keypress(function (e) {
    if (e.keyCode == 13) {
      this.blur();
    }
  });
  $("#Es").keypress(function (e) {
    if (e.keyCode == 13) {
      this.blur();
    }
  });

  // bond
  $("#Taub0").keypress(function (e) {
    if (e.keyCode == 13) {
      this.blur();
    }
  });
  $("#Taub1").keypress(function (e) {
    if (e.keyCode == 13) {
      this.blur();
    }
  });
});

// concrete

$("#conFct").blur(function (e) {
  if (isNaN(parseFloat($("#conFct").html()))) {
    setTimeout(function () {
      document.getElementById("conFct").focus();
    }, 10);
    return;
  }

  if (parseFloat($("#conFct").html()) !== fct) {
    if (parseFloat($("#conFct").html()) <= 0) {
      bootbox.alert({
        message: "Die Eingabe ist zu klein.",
        callback: function () {
          setTimeout(function () {
            document.getElementById("conFct").focus();
          }, 500);
        },
      });
      return;
    }
    if (
      parseFloat($("#conFct").html()) /
        (fsu - parseFloat($("#conFct").html()) * (Es / Ec - 1)) >
        0.1 ||
      parseFloat($("#conFct").html()) /
        (fsu - parseFloat($("#conFct").html()) * (Es / Ec - 1)) <
        0
    ) {
      let alertmsg =
        "Die Eingabe führt zu einem Mindestbewehrungsgehalt grösser als 10% und ist somit nicht praxisrelevant.";
      if (lang == "en") {
        alertmsg =
          "The input leads to a minimum reinforcement content greater than 10% and is therefore not relevant in practice.";
      }
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("conFct").focus();
          }, 500);
        },
      });
      return;
    }
    fct = parseFloat($("#conFct").html());
    $("#conType").val(6);
    if (parseFloat($("#bondType").val()) == 0) {
      taub0 = 2 * fct;
      taub1 = fct;
      $("#Taub0").html(taub0);
      $("#Taub1").html(taub1);
    }
    checkminrho();
    updateCalc();
  }
  $("#conFct").html(math.round(fct * 10000) / 10000);
});

$("#conEc").blur(function (e) {
  if (isNaN(parseFloat($("#conEc").html()))) {
    setTimeout(function () {
      document.getElementById("conEc").focus();
    }, 10);
    return;
  }
  if (parseFloat($("#conEc").html()) !== math.round(Ec / 10) / 100) {
    let alertmsg = "Die Eingabe ist zu klein.";
    if (lang == "en") {
      alertmsg = "The input is too small.";
    }
    if (parseFloat($("#conEc").html()) <= 0) {
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("conEc").focus();
          }, 500);
        },
      });
      return;
    }
    if (
      fct / (fsu - fct * (Es / (parseFloat($("#conEc").html()) * 1000) - 1)) +
        0.000001 >
        0.1 ||
      fct / (fsu - fct * (Es / (parseFloat($("#conEc").html()) * 1000) - 1)) +
        0.000001 <
        0
    ) {
      let alertmsg =
        "Die Eingabe führt zu einem Mindestbewehrungsgehalt grösser als 10% und ist somit nicht praxisrelevant.";
      if (lang == "en") {
        alertmsg =
          "The input leads to a minimum reinforcement content greater than 10% and is therefore not relevant in practice.";
      }
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("conEc").focus();
          }, 500);
        },
      });
      return;
    }

    Ec = parseFloat($("#conEc").html()) * 1000;
    $("#conType").val(6);
    checkminrho();
    updateCalc();
  }
  $("#conEc").html(math.round(Ec / 10) / 100);
});

// Steel
$("#refFsy").blur(function (e) {
  if (isNaN(parseFloat($("#refFsy").html()))) {
    setTimeout(function () {
      document.getElementById("refFsy").focus();
    }, 10);
    return;
  }

  if (parseFloat($("#refFsy").html()) !== fsy) {
    if (parseFloat($("#refFsy").html()) <= 0) {
      let alertmsg = "Die Eingabe ist zu klein.";
      if (lang == "en") {
        alertmsg = "The input is too small.";
      }
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("refFsy").focus();
          }, 500);
        },
      });
      return;
    }
    if (parseFloat($("#refFsy").html()) > fsu) {
      let alertmsg = "Die Eingabe muss kleiner als fsu sein.";
      if (lang == "en") {
        alertmsg = "The input must be smaller than fsu.";
      }
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("refFsy").focus();
          }, 500);
        },
      });
      return;
    }
    fsy = math.min(parseFloat($("#refFsy").html()), fsu - 0.000001);
    esy = fsy / Es;
    Esh = (fsu - fsy) / (esu - esy);
    $("#refType").val(4);
    $("#refks").html(math.round((fsu / fsy) * 100) / 100);
    updateCalc();
  }
  $("#refFsy").html(math.round(fsy * 10000) / 10000);
});

$("#refFsu").blur(function (e) {
  if (isNaN(parseFloat($("#refFsu").html()))) {
    setTimeout(function () {
      document.getElementById("refFsu").focus();
    }, 10);
    return;
  }

  if (parseFloat($("#refFsu").html()) !== fsu) {
    if (parseFloat($("#refFsu").html()) < fsy) {
      let alertmsg = "Die Eingabe muss grösser als fsy sein.";
      if (lang == "en") {
        alertmsg = "The input must be bigger than fsy.";
      }
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("refFsu").focus();
          }, 500);
        },
      });
      return;
    }

    fsu = math.max(parseFloat($("#refFsu").html()), fsy + 0.000001);
    Esh = (fsu - fsy) / (esu - esy);
    $("#refType").val(4);
    $("#refks").html(math.round((fsu / fsy) * 100) / 100);
    checkminrho();
    updateCalc();
  }

  $("#refFsu").html(math.round(fsu * 10000) / 10000);
});

$("#refEsu").blur(function (e) {
  if (isNaN(parseFloat($("#refEsu").html()))) {
    setTimeout(function () {
      document.getElementById("refEsu").focus();
    }, 10);
    return;
  }

  if (parseFloat($("#refEsu").html()) !== esu * 1000) {
    if (parseFloat($("#refEsu").html()) < esy * 1000) {
      let alertmsg =
        "Die Eingabe muss grösser als fsk/Es=" +
        math.round((fsy / Es) * 1000 * 100) / 100 +
        "‰ sein.";
      if (lang == "en") {
        alertmsg =
          "The input must be bigger than fsk/Es=" +
          math.round((fsy / Es) * 1000 * 100) / 100 +
          "‰.";
      }
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("refEsu").focus();
          }, 500);
        },
      });
      return;
    }

    esu = math.max(parseFloat($("#refEsu").html()) / 1000, esy + 0.000000001);
    Esh = (fsu - fsy) / (esu - esy);
    $("#refType").val(4);
    updateCalc();
  }
  $("#refEsu").html(math.round(esu * 10000000) / 10000);
});

$("#Es").blur(function (e) {
  if (isNaN(parseFloat($("#Es").html()))) {
    setTimeout(function () {
      document.getElementById("Es").focus();
    }, 10);
    return;
  }

  if (parseFloat($("#Es").html()) * 1000 !== Es) {
    if (parseFloat($("#Es").html()) < 0) {
      let alertmsg = "Die Eingabe ist zu klein.";
      if (lang == "en") {
        alertmsg = "The input is too small.";
      }
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("Es").focus();
          }, 500);
        },
      });
      return;
    }
    if (fsy / (parseFloat($("#Es").html()) * 1000) >= esu) {
      let alertmsg =
        "Die Eingabe muss grösser als fsk/esu=" +
        math.round((fsy / esu / 1000) * 100) / 100 +
        "GPa sein.";
      if (lang == "en") {
        alertmsg =
          "The input must be bigger than fsk/esu=" +
          math.round((fsy / esu / 1000) * 100) / 100 +
          "GPa.";
      }
      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("Es").focus();
          }, 500);
        },
      });
      return;
    }

    Es = math.max(parseFloat($("#Es").html()) * 1000, 0.001);

    esy = fsy / Es;
    Esh = (fsu - fsy) / (esu - esy);

    $("#refType").val(4);
    updateCalc();
  }
  $("#refEsu").html(math.round(esu * 10000000) / 10000);
});

// Bond
$("#Taub0").blur(function (e) {
  if (isNaN(parseFloat($("#Taub0").html()))) {
    setTimeout(function () {
      document.getElementById("Taub0").focus();
    }, 10);
    return;
  }

  if (parseFloat($("#Taub0").html()) !== taub0) {
    if (parseFloat($("#Taub0").html()) < 0.00001) {
      let alertmsg =
        "Die Eingabe ist zu klein. Bitte wähle einen Wert grösser als 0.00001";
      if (lang == "en") {
        alertmsg =
          "The input is too small. Please select a value greater than 0.00001";
      }

      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("Taub0").focus();
          }, 500);
        },
      });
      return;
    }
    taub0 = math.max(parseFloat($("#Taub0").html()), 0.00001);
    if (bType == 0) {
      bType = 1;
      $("#bondType").val(1);
      $("#Taub0formula").html("$\\tau_{b0}$");
      MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#Taub0formula"]);
      $("#Taub1formula").html("$\\tau_{b1}$");
      MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#Taub1formula"]);
    }
    updateCalc();
  }
  $("#Taub0").html(math.round(taub0 * 100000) / 100000);
});
$("#Taub1").blur(function (e) {
  if (isNaN(parseFloat($("#Taub1").html()))) {
    setTimeout(function () {
      document.getElementById("Taub1").focus();
    }, 10);
    return;
  }

  if (parseFloat($("#Taub1").html()) !== taub1) {
    if (parseFloat($("#Taub1").html()) < 0.00001) {
      let alertmsg =
        "Die Eingabe ist zu klein. Bitte wähle einen Wert grösser als 0.00001";
      if (lang == "en") {
        alertmsg =
          "The input is too small. Please select a value greater than 0.00001";
      }

      bootbox.alert({
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("Taub1").focus();
          }, 500);
        },
      });

      return;
    }
    taub1 = math.max(parseFloat($("#Taub1").html()), 0.00001);
    if (bType == 0) {
      bType = 1;
      $("#bondType").val(1);
      $("#Taub0formula").html("$\\tau_{b0}$");
      MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#Taub0formula"]);
      $("#Taub1formula").html("$\\tau_{b1}$");
      MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#Taub1formula"]);
    }
    updateCalc();
  }
  $("#Taub1").html(math.round(taub1 * 100000) / 100000);
});

function checkminrho() {
  // check rho
  minrho = fct / (fsu - fct * (Es / Ec - 1)) + 0.000001;
  if (rho < minrho) {
    rho = minrho + 0.00000001;

    $('.nav-tabs a[href="#CtrlGeom"]').tab("show");
    setTimeout(function () {
      $("#rho").val(rho * 100);
      document.getElementById("rho").classList.add("is-invalid");
      document.getElementById("Ctrl").classList.add("focus");

      let alertmsg =
        "Der Bewehrungsgehalt ist zu klein und führt zu einem spröden Versagen des Zuggurts (Stichwort: Mindestbewehrung). <br><br>Der Wert wurde auf ρ=fct/(fsu-fct*(n-1))=" +
        math.round(minrho * 100000) / 1000 +
        "% gesetzt, sodass die Bewehrung beim Reissen des Elements gerade nicht bricht.";

      if (lang == "en") {
        alertmsg =
          "The reinforcement content is too small and leads to a brittle failure of the tension chord (keyword: minimum reinforcement). <br><br>The value was set to ρ=fct/(fsu-fct*(n-1))=" +
          math.round(minrho * 100000) / 1000 +
          "% so that the reinforcement just does not rupture when the element is cracked.";
      }

      bootbox.alert({
        size: "large",
        message: alertmsg,
        callback: function () {
          setTimeout(function () {
            document.getElementById("rho").classList.remove("is-invalid");
            document.getElementById("Ctrl").classList.remove("focus");
          }, 500);
        },
      });
    }, 300);
  }

  var slidervalue = parseFloat(sliderN.noUiSlider.get());
  sliderN.noUiSlider.updateOptions({
    range: {
      min: 0,
      max: Math.round(fsu * Ac * rho) / 1000,
    },
  });

  sliderN.noUiSlider.set(math.min(slidervalue, (Ac * rho * fsu) / 1000));
  N_marker = math.min(slidervalue * 1000, Ac * rho * fsu);
  if (math.round(N_marker) == math.round(Ac * rho * fsu)) {
    N_marker = Ac * rho * fsu;
  }
  $("#formN").attr("max", Math.round(fsu * Ac * rho) / 1000);

  var slidervalue = parseFloat(sliderN.noUiSlider.get());
  sliderN.noUiSlider.updateOptions({
    range: {
      min: 0,
      max: math.ceil((fsu * Ac * rho) / 1000),
    },
  });

  sliderN.noUiSlider.set(math.min(slidervalue, (Ac * rho * fsu) / 1000));
  N_marker = math.min(slidervalue * 1000, Ac * rho * fsu);
  if (math.round(N_marker / 100) == math.round((Ac * rho * fsu) / 100)) {
    N_marker = Ac * rho * fsu;
  }
  $("#formN").attr("max", math.ceil((Ac * rho * fsu) / 1000));
}

function updateranges() {
  var sigma_sr0 = (fct / rho) * (1 + rho * (Es / Ec - 1));
  var sr0 = (fct * D * (1 - rho)) / (2 * taub0 * rho);
  srm = Lambda * sr0;
  var w_r_max = f_wr(
    fsu,
    fsy,
    Es,
    fsu,
    Esh,
    esy,
    taub0,
    taub1,
    srm,
    D,
    Ec,
    fct,
    rho
  );

  range_sigma_c_init = [0, 20];
  range_sigma_s_init = [0, fsu * 1.02];
  range_eps_c_init = [0, 0.5];
  range_eps_s_init = [0, esu * 1.02 * 1000];
  range_u_c_init = math.dotMultiply(
    [-1, 1],
    ((1.05 * sigma_sr0 * rho) / (1 + (Es / Ec) * rho - rho) / Ec) * srm
  );

  //range_u_c_init=math.dotMultiply([-1, 1],1.05*fct*fct*D*(1-minrho)/(2*taub0*minrho)/4/Ec);
  range_u_s_init = math.dotMultiply([-1, 1], 1.05 * w_r_max[0]);
  range_tau_init = [-1.02 * 2 * fct, 1.02 * 2 * fct];
}

range_esm_init = [0, esu * 1.05 * 1000];
range_N_init = [0, (fsu * Ac * rho * 1.05) / 1000];
var w_r_max = f_wr(
  fsu,
  fsy,
  Es,
  fsu,
  Esh,
  esy,
  taub0,
  taub1,
  srm,
  D,
  Ec,
  fct,
  rho
);
range_wr_init = [0, 2 * w_r_max[0] * 1.05];

function updateCalc() {
  updateranges();
  var sigma_sr;

  var sr0 = (fct * D * (1 - rho)) / (2 * taub0 * rho);
  srm = Lambda * sr0;
  var As = Ac * rho;
  var Nmax = fsu * As;
  var sigma_sr0 = (fct / rho) * (1 + rho * (Es / Ec - 1));

  var N = math.range(0, Nmax + 1000, 1000);
  N._data[N._data.length - 1] = Nmax;
  var esm = math.zeros(N.size()[0]);
  var w_r = math.zeros(N.size()[0]);
  var w_r_woc = math.zeros(N.size()[0]);

  wr_magnification = parseFloat($("#wr_magnification").val());

  // Mean strain esm and crack width w_r for each stress value
  for (i = 0; i < esm._data.length; i++) {
    sigma_sr = N._data[i] / As;
    esm._data[i] = f_esm(
      sigma_sr,
      fsy,
      Es,
      fsu,
      Esh,
      esy,
      taub0,
      taub1,
      srm,
      D,
      Ec,
      fct,
      rho
    );
    var u_sc = f_wr(
      sigma_sr,
      fsy,
      Es,
      fsu,
      Esh,
      esy,
      taub0,
      taub1,
      srm,
      D,
      Ec,
      fct,
      rho
    );
    w_r._data[i] = (u_sc[0] - u_sc[1]) * 2;
    w_r_woc._data[i] = u_sc[0] * 2;
    if (i == esm._data.length - 1) {
    }
  }

  // calculate TC props
  var innerTC = InnerTC(
    N_marker / As,
    fsy,
    Es,
    fsu,
    Esh,
    esy,
    taub0,
    taub1,
    srm,
    D,
    Ec,
    fct,
    rho
  );

  // set marker
  var esm_marker = f_esm(
    N_marker / As,
    fsy,
    Es,
    fsu,
    Esh,
    esy,
    taub0,
    taub1,
    srm,
    D,
    Ec,
    fct,
    rho
  );

  var u_sc = f_wr(
    N_marker / As,
    fsy,
    Es,
    fsu,
    Esh,
    esy,
    taub0,
    taub1,
    srm,
    D,
    Ec,
    fct,
    rho
  );
  w_r_marker = (u_sc[0] - u_sc[1]) * 2;
  if (N_marker / As < sigma_sr0) {
    var ecm_marker = esm_marker;
  } else {
    var ecm_marker = ((u_sc[1] * 2) / srm) * 1000;
  }

  // set HTML values
  if (N_marker / As < sigma_sr0) {
    $("#sigma_sr").html(
      math.round(
        (((((N_marker / As) * rho) / (1 + (Es / Ec) * rho - rho)) * Es) / Ec) *
          100
      ) / 100
    );
  } else {
    $("#sigma_sr").html(math.round((N_marker / As) * 100) / 100);
  }
  $("#s_rm").html(math.round(srm * 100) / 100);
  $("#w_r").html(math.round(w_r_marker * 1000) / 1000);

  $("#epsilon_sm").html(math.round(esm_marker * 1000) / 1000);

  let esm_naked;
  if (N_marker / As < fsy) {
    esm_naked = N_marker / As / Es;
  } else {
    esm_naked = fsy / Es + (N_marker / As - fsy) / Esh;
  }

  $("#delta_epsilon").html(
    math.round((esm_naked * 1000 - esm_marker) * 1000) / 1000
  );

  /******
   * Drawing of Crack Element
   *******/
  tempSec = new Group();

  // Concrete
  if (N_marker / As < sigma_sr0) {
    //if not cracked
    tempSec.addElm(new Rectangle(w, 2 * srm, 0, 0).setFill(greena));
    tempSec.addElm(new Rectangle(0, 0, 0, 0).setFill(greena));
    tempSec.addElm(new Line([w / 2, w / 2], [1, 1]));
    tempSec.addElm(new Line([w / 2, w / 2], [1, 1]));
    tempSec.addElm(new Line([w / 2, w / 2], [1, 1]));
    tempSec.addElm(new Line([w / 2, w / 2], [1, 1]));
  } else {
    tempSec.addElm(
      new Rectangle(
        w,
        srm,
        0,
        srm / 2 + (wr_magnification * w_r_marker) / 2
      ).setFill(greena)
    );
    tempSec.addElm(
      new Rectangle(
        w,
        srm,
        0,
        -(srm / 2 + (wr_magnification * w_r_marker) / 2)
      ).setFill(greena)
    );

    x = [];
    let y1 = [];
    let y2 = [];
    let y3 = [];
    let y4 = [];

    for (let jj = 0; jj < 101; jj++) {
      x[jj] = -w / 2 + (w / 100) * jj;
      y1[jj] =
        math.sin((x[jj] * 2 * 3.1415) / (w / 20)) * 3 -
        (wr_magnification * w_r_marker) / 2;
      y2[jj] =
        math.sin((x[jj] * 2 * 3.1415) / (w / 20)) * 3 +
        (wr_magnification * w_r_marker) / 2;
      y3[jj] =
        math.sin((x[jj] * 2 * 3.1415) / (w / 20)) * 3 -
        (wr_magnification * w_r_marker) / 2 -
        srm;
      y4[jj] =
        math.sin((x[jj] * 2 * 3.1415) / (w / 20)) * 3 +
        (wr_magnification * w_r_marker) / 2 +
        srm;
    }
    tempSec.addElm(new Line(x, y1));
    tempSec.addElm(new Line(x, y2));
    tempSec.addElm(new Line(x, y3));
    tempSec.addElm(new Line(x, y4));
  }
  // Rebar
  tempSec.addElm(
    new Rectangle(
      (D / 300) * w,
      2 * (srm + wr_magnification * w_r_marker),
      0,
      0
    ).setFill("rgba(50,50,255,0.5)")
  );

  // Arrows
  let length = N_marker / 10000;
  let arrow_scale = length;
  arrowlength = arrow_head_length_scale + arrow_scale;
  if (N_marker < 0.1) {
    tempSec.addElm(
      new Arrow(
        0,
        -(srm + wr_magnification * w_r_marker + gap + arrowlength),
        0,
        180,
        0
      ).setFill(col.forces.getRgba())
    );
    tempSec.addElm(
      new Arrow(
        0,
        -(srm + wr_magnification * w_r_marker + gap + arrowlength),
        0,
        0,
        0
      ).setFill(col.forces.getRgba())
    );
  } else {
    tempSec.addElm(
      new Arrow(
        0,
        -(srm + wr_magnification * w_r_marker + gap + arrowlength),
        arrowlength,
        180,
        arrow_head_length_scale / arrow_head_length
      ).setFill(col.forces.getRgb())
    );
    tempSec.addElm(
      new Arrow(
        0,
        -(srm + wr_magnification * w_r_marker + gap + arrowlength),
        arrowlength,
        0,
        arrow_head_length_scale / arrow_head_length
      ).setFill(col.forces.getRgb())
    );
  }

  var sigma_steel_plot = [
    {
      x: [innerTC[0].x[0], ...innerTC[0].x, ...[innerTC[0].x[0]]],
      y: [
        0,
        ...math.add(innerTC[0].y, (wr_magnification * w_r_marker) / 2),
        ...[
          innerTC[0].y[innerTC[0].y.length - 1] + wr_magnification * w_r_marker,
        ],
      ],
    },
    {
      x: [innerTC[0].x[0], ...innerTC[0].x, ...[innerTC[0].x[0]]],
      y: [
        0,
        ...math.subtract((-wr_magnification * w_r_marker) / 2, innerTC[0].y),
        ...[
          -innerTC[0].y[innerTC[0].y.length - 1] -
            wr_magnification * w_r_marker,
        ],
      ],
    },
  ];

  var sigma_concrete_plot = [
    {
      x: innerTC[1].x,
      y: math.add(innerTC[1].y, (wr_magnification * w_r_marker) / 2),
    },
    {
      x: innerTC[1].x,
      y: math.subtract((-wr_magnification * w_r_marker) / 2, innerTC[1].y),
    },
  ];

  var epsilon_steel_plot = [
    {
      x: [innerTC[2].x[0], ...innerTC[2].x, ...[innerTC[2].x[0]]],
      y: [
        0,
        ...math.add(innerTC[2].y, (wr_magnification * w_r_marker) / 2),
        ...[
          innerTC[2].y[innerTC[0].y.length - 1] + wr_magnification * w_r_marker,
        ],
      ],
    },
    {
      x: [innerTC[2].x[0], ...innerTC[2].x, ...[innerTC[2].x[0]]],
      y: [
        0,
        ...math.subtract((-wr_magnification * w_r_marker) / 2, innerTC[2].y),
        ...[
          -innerTC[2].y[innerTC[2].y.length - 1] -
            wr_magnification * w_r_marker,
        ],
      ],
    },
  ];

  var epsilon_concrete_plot = [
    {
      x: innerTC[3].x,
      y: math.add(innerTC[3].y, (wr_magnification * w_r_marker) / 2),
    },
    {
      x: innerTC[3].x,
      y: math.subtract((-wr_magnification * w_r_marker) / 2, innerTC[3].y),
    },
  ];

  var u_steel_plot = [
    {
      x: [
        innerTC[4].x._data[0],
        ...innerTC[4].x._data,
        ...[innerTC[4].x._data[innerTC[4].y._data.length - 1]],
      ],
      y: [
        0,
        ...math.add(innerTC[4].y._data, (wr_magnification * w_r_marker) / 2),
        ...[
          innerTC[4].y._data[innerTC[4].y._data.length - 1] +
            wr_magnification * w_r_marker,
        ],
      ],
    },
    {
      x: [
        innerTC[4].x._data[0],
        ...innerTC[4].x._data,
        ...[innerTC[4].x._data[innerTC[4].y._data.length - 1]],
      ],
      y: [
        -innerTC[4].y._data[innerTC[4].y._data.length - 1] -
          wr_magnification * w_r_marker,
        ...math.add(
          innerTC[4].y._data,
          (-wr_magnification * w_r_marker) / 2 -
            [innerTC[4].y._data[innerTC[4].y._data.length - 1]]
        ),
        ...[0],
      ],
    },
  ];

  var u_concrete_plot = [
    {
      x: [0, ...innerTC[5].x._data, ...[0]],
      y: math.add(
        [
          0,
          ...innerTC[5].y._data,
          ...[innerTC[5].y._data[innerTC[5].y._data.length - 1]],
        ],
        (wr_magnification * w_r_marker) / 2
      ),
    },
    {
      x: [0, ...innerTC[5].x._data, ...[0]],
      y: [
        -innerTC[5].y._data[innerTC[5].y._data.length - 1] -
          (wr_magnification * w_r_marker) / 2,
        ...math.add(
          innerTC[5].y._data,
          (-wr_magnification * w_r_marker) / 2 -
            [innerTC[5].y._data[innerTC[5].y._data.length - 1]]
        ),
        ...[(-wr_magnification * w_r_marker) / 2],
      ],
    },
  ];

  if (N_marker / As < sigma_sr0) {
    u_steel_plot[1].x = math.dotMultiply(u_steel_plot[1].x, -1);
    u_concrete_plot[1].x = math.dotMultiply(u_concrete_plot[1].x, -1);
    u_concrete_plot[1].x.reverse();
    u_steel_plot[1].x.reverse();
  }

  var tau_b_plot = [
    {
      x: [0, ...innerTC[6].x, ...[0]],
      y: math.add(
        [0, ...innerTC[6].y, ...[innerTC[6].y[innerTC[6].y.length - 1]]],
        (wr_magnification * w_r_marker) / 2
      ),
    },
    {
      x: [0, ...innerTC[6].x, ...[0]],
      y: math.add(
        [0, ...innerTC[6].y, ...[innerTC[6].y[innerTC[6].y.length - 1]]],
        (-wr_magnification * w_r_marker) / 2 -
          [innerTC[6].y[innerTC[6].y.length - 1]]
      ),
    },
  ];

  if (init < 1) {
    let alertmsg = [
      "Nackter Stahl",
      "Zuggurt",
      "Zugversagen des Zuggurts: Stahlreissen bei <i>N</i> = %{y:,.1f} kN , ε<sub><i>sm</i></sub> = %{x:,.3f} ‰",
      "Zugversagen des nackten Stahls: Stahlreissen bei <i>N</i> = %{y:,.1f} kN , ε<sub><i>s</i></sub> = %{x:,.3f} ‰",
    ];
    if (lang == "en") {
      alertmsg = [
        "Bare steel",
        "Tension chord",
        "Tension failure of the tension chord: steel rupture at <i>N</i> = %{y:,.1f} kN , ε<sub><i>sm</i></sub> = %{x:,.3f} ‰",
        "Tensile failure of the bare steel: steel cracks at <i>N</i> = %{y:,.1f} kN , ε<sub><i>s</i></sub> = %{x:,.3f} ‰",
      ];
    }
    // esm - N plot
    (data = {
      plotData: [
        {
          x: [0, esy * 1000, esu * 1000],
          y: math.dotDivide([0, fsy * As, fsu * As], 1000),
          rangemode: "tozeroy",

          type: "scatter",
          mode: "lines",
          name: alertmsg[0],
          line: {
            dash: "dot",
            width: 1,
            color: "rgb(100,100,100)",
          },
          hoverinfo: "none",
        },
        {
          x: esm._data,
          y: math.dotDivide(N._data, 1000),
          rangemode: "tozeroy",

          type: "scatter",
          mode: "lines",
          name: alertmsg[1],
          line: {
            width: 1,
            color: "rgb(100,100,100)",
          },
          hoverinfo: "none",
        },
        {
          x: [esm._data[esm._data.length - 1]],
          y: math.dotDivide([fsu * As], 1000),
          mode: "markers",
          marker: {
            color: "rgb(0, 0, 0)",
            size: 5,
            symbol: "x",
            line: {
              width: 0.0,
            },
          },
          name: "",
          hovertemplate: alertmsg[2],
          showlegend: false,
        },
        {
          x: [esu * 1000],
          y: math.dotDivide([fsu * As], 1000),
          mode: "markers",
          marker: {
            color: "rgb(0, 0, 0)",
            size: 5,
            symbol: "x",
            line: {
              width: 0.0,
            },
          },
          name: "",
          hovertemplate: alertmsg[3],
          showlegend: false,
        },
        {
          x: [esm_marker],
          y: math.dotDivide(N_marker, 1000),
          mode: "markers",
          marker: {
            color: "rgb(255, 0, 0)",
            size: 5,
          },
          name: "",
          hovertemplate:
            "<i>N</i> = %{y:,.0f} kN , ε<sub><i>sm</i></sub> = %{x:,.3f} ‰",
          showlegend: false,
        },
      ],

      plotLayout: {
        hovermode: "closest",
        hoverlabel: { bgcolor: "#FFF" },
        height: 300,
        margin: {
          l: 60,
          r: 30,
          b: 40,
          t: 30,
          pad: 0,
        },
        xaxis: {
          title: "ε<sub><i>sm</i></sub> [‰]",
          rangemode: "tozero",
          range: range_esm_init,
        },
        yaxis: {
          title: "<i>N</i> [kN]",
          rangemode: "tozero",
          range: range_N_init,
        },
        showlegend: true,
        legend: {
          xanchor: "right",
          x: 1,
          y: 0.5,
        },
      },
    }),
      (init = 1);
    if (window.checkMobile() == true) {
      data.plotLayout.dragmode = false;
    }

    pltConfig.doubleClick = false;

    pltConfig.modeBarButtons = [
      ["zoom2d", "pan2d"],
      [
        "zoomIn2d",
        "zoomOut2d",
        {
          name: "myResetScale2d",
          title: "Reset axes",
          icon: Plotly.Icons.home,
          click: function () {
            NdoubleClick_event();
          },
        },
      ],
    ];

    var plotname = document.getElementById("plotNepsilon");
    Plotly.newPlot("plotNepsilon", data.plotData, data.plotLayout, pltConfig);
    plotname.on("plotly_doubleclick", function () {
      NdoubleClick_event();
    });

    // wr - N plot

    alertmsg = [
      "inkl. Betonverformungen",
      "exkl. Betonverformungen",
      "Zugversagen des Zuggurts unter Berücksichtigung der Betonverformungen: Stahlreissen bei <i>N</i> = %{y:,.1f} kN , w<sub><i>r</i></sub> = %{x:,.3f} mm",
      "Zugversagen des Zuggurts unter Vernachlässigung der Betonverformungen: Stahlreissen bei <i>N</i> = %{y:,.1f} kN , w<sub><i>r</i></sub> = %{x:,.3f} mm",
    ];
    if (lang == "en") {
      alertmsg = [
        "incl. concrete deformations",
        "excl. concrete deformations",
        "Tension failure of the tension chord considering concrete deformations: Steel cracking at <i>N</i> = %{y:,.1f} kN , ε<sub><i>sm</i></sub> = %{x:,.3f} ‰",
        "Tension failure of the tension chord neglecting concrete deformations: Steel cracking at <i>N</i> = %{y:,.1f} kN , ε<sub><i>s</i></sub> = %{x:,.3f} ‰",
      ];
    }

    data = {
      plotData: [
        {
          x: w_r._data,
          y: math.dotDivide(N._data, 1000),
          rangemode: "tozeroy",

          type: "scatter",
          mode: "lines",
          name: alertmsg[0],
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(100,100,100)",
          },
          hoverinfo: "none",
        },
        {
          x: w_r_woc._data,
          y: math.dotDivide(N._data, 1000),
          rangemode: "tozeroy",

          type: "scatter",
          mode: "lines",
          name: alertmsg[1],
          line: {
            dash: "dot",
            width: 1,
            color: "rgb(100,100,100)",
          },
          hoverinfo: "none",
        },
        {
          x: [w_r._data[w_r._data.length - 1]],
          y: math.dotDivide([fsu * As], 1000),
          mode: "markers",
          marker: {
            color: "rgb(0, 0, 0)",
            size: 5,
            symbol: "x",
            line: {
              width: 0.0,
            },
          },
          name: "",
          hovertemplate: alertmsg[2],
          showlegend: false,
        },
        {
          x: [w_r_woc._data[w_r_woc._data.length - 1]],
          y: math.dotDivide([fsu * As], 1000),
          mode: "markers",
          marker: {
            color: "rgb(0, 0, 0)",
            size: 5,
            symbol: "x",
            line: {
              width: 0.0,
            },
          },
          name: "",
          hovertemplate: alertmsg[3],
          showlegend: false,
        },
        {
          x: [w_r_marker],
          y: math.dotDivide([N_marker], 1000),
          mode: "markers",
          marker: {
            color: "rgb(255, 0, 0)",
            size: 5,
          },
          name: "",
          hovertemplate:
            "<i>N</i> = %{y:,.0f} kN , w<sub><i>r</i></sub> = %{x:,.3f} mm",
          showlegend: false,
        },
      ],
      plotLayout: {
        hovermode: "closest",
        hoverlabel: { bgcolor: "#FFF" },
        height: 300,
        margin: {
          l: 60,
          r: 30,
          b: 40,
          t: 30,
          pad: 0,
        },
        xaxis: {
          title: "w<sub><i>r</i></sub> [mm]",
          rangemode: "tozero",
          range: range_wr_init,
          // [0, X.max],
        },
        yaxis: {
          title: "<i>N</i> [kN]",
          rangemode: "tozero",
          range: range_N_init,
        },
        showlegend: true,
        legend: {
          xanchor: "right",
          x: 1,
          y: 0.5,
        },
      },
    };
    if (window.checkMobile() == true) {
      data.plotLayout.dragmode = false;
    }
    var plotname = document.getElementById("plotNwr");
    Plotly.newPlot("plotNwr", data.plotData, data.plotLayout, pltConfig);
    plotname.on("plotly_doubleclick", function () {
      NdoubleClick_event();
    });

    // TC element
    let layout = {
      hovermode: false,
      height: he,
      //width: we,
      margin: {
        l: 50,
        r: 0,
        b: 55,
        t: 45,
        pad: 0,
      },
      xaxis: {
        domain: [0.05, 1],
        rangemode: "tozero",
        fixedrange: true,
        showgrid: false,
        zeroline: false,
        showline: false,
        autotick: true,
        ticks: "",
        showticklabels: false,
      },

      yaxis: {
        title: "[mm]",
        domain: [0, 1],
        //rangemode: 'tozero',
        //autorange: true,
        range: [range_y_init[0], range_y_init[1]],
      },

      showlegend: false,
      legend: {
        x: 1,
        y: 0.5,
      },
    };
    let pltSec = tempSec.getPlotData();
    var data = pltSec.data;

    if (window.checkMobile() == true) {
      layout.dragmode = false;
    }
    pltConfig.doubleClick = false;

    pltConfig.modeBarButtons = [
      ["zoom2d", "pan2d"],
      [
        "zoomIn2d",
        "zoomOut2d",
        {
          name: "myResetScale2d",
          title: "Reset axes",
          icon: Plotly.Icons.home,
          click: function () {
            doubleClick_event();
          },
        },
      ],
    ];

    Plotly.plot(plotElement, data, layout, pltConfig);

    plotElement.on("plotly_relayout", function (eventdata) {
      ZoomCallback(
        ["plotTC_stress", "plotTC_strain", "plotTC_u", "plotTC_tau"],
        ["y", "y", "y", "y"],
        [eventdata["xaxis.range[0]"], eventdata["xaxis.range[1]"]],
        [eventdata["yaxis.range[0]"], eventdata["yaxis.range[1]"]]
      );
    });
    plotElement.on("plotly_doubleclick", function () {
      doubleClick_event();
    });

    // TC Stress
    alertmsg = ["Stahl", "Fliessgrenze des Stahls", "Beton"];
    if (lang == "en") {
      alertmsg = ["Steel", "Yield strength of the steel", "Concrete"];
    }
    data = {
      plotData: [
        // Steel stresses
        {
          x: sigma_steel_plot[0].x,
          y: sigma_steel_plot[0].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",

          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          name: alertmsg[0],
          showlegend: false,
        },
        {
          x: sigma_steel_plot[1].x,
          y: sigma_steel_plot[1].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",

          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },

          showlegend: false,
        },
        {
          x: sigma_steel_plot[0].x,
          y: sigma_steel_plot[0].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          hoverinfo: "x",
          line: {
            dash: "solid",
            width: 2,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: blue9,
          name: "",
          hovertemplate: "σ<sub><i><i></i></i></sub> = %{x:,.2f} MPa",
        },
        {
          x: sigma_steel_plot[1].x,
          y: sigma_steel_plot[1].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          hoverinfo: "x",
          line: {
            dash: "solid",
            width: 2,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: blue9,
          name: "",
          hovertemplate: "σ<sub><i>s</i></sub> = %{x:,.2f} MPa",
        },
        {
          x: [fsy, fsy],
          y: [-2 * srm, 2 * srm],
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          hoverinfo: "none",
          line: {
            dash: "dot",
            width: 1,
            color: "rgb(100,100,255)",
          },
          showlegend: true,
          name: alertmsg[1],
        },

        // Concrete Stresses
        {
          x: sigma_concrete_plot[0].x,
          y: sigma_concrete_plot[0].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",

          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
        },
        {
          x: sigma_concrete_plot[1].x,
          y: sigma_concrete_plot[1].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",

          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
        },
        {
          x: sigma_concrete_plot[0].x,
          y: sigma_concrete_plot[0].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          name: alertmsg[2],
          showlegend: false,
          fill: "tozerox",
          fillcolor: green9,
          name: "",
          hovertemplate: "σ<sub><i>c</i></sub> = %{x:,.2f} MPa",
        },
        {
          x: sigma_concrete_plot[1].x,
          y: sigma_concrete_plot[1].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",

          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: green9,
          name: "",
          hovertemplate: "σ<sub><i>c</i></sub> = %{x:,.2f} MPa",
        },
      ],
      plotLayout: {
        hovermode: "closest",
        height: he,
        margin: {
          l: 0,
          r: 15,
          b: 50,
          t: 50,
          pad: 0,
        },

        yaxis: {
          //title: 'N [N]',
          domain: [0, 1],
          //rangemode: 'tozero',
          //autorange: true,
          range: [range_y_init[0], range_y_init[1]],
          ticks: "",
          showticklabels: false,
        },
        xaxis1: {
          title: "σ<sub><i></i></sub> [MPa]",

          titlefont: {
            color: "rgb(0,0,200)",
          },
          tickfont: {
            color: "rgb(0,0,200)",
          },

          domain: [domain_l, domain_r],
          rangemode: "tozero",
          range: [range_sigma_s_init[0], range_sigma_s_init[1]],
        },
        xaxis2: {
          title: "σ<sub><i>c</i></sub> [MPa]",
          titlefont: {
            color: "rgb(0,200,0)",
          },
          tickfont: {
            color: "rgb(0,200,0)",
          },
          overlaying: "x1",

          side: "top",
          domain: [domain_l, domain_r],
          rangemode: "tozero",
          range: [range_sigma_c_init[0], range_sigma_c_init[1]],
        },
        showlegend: true,
        legend: {
          xanchor: "center",
          x: 0.5,
          y: 0.95,
        },
      },
    };

    if (window.checkMobile() == true) {
      data.plotLayout.dragmode = false;
    }
    Plotly.newPlot("plotTC_stress", data.plotData, data.plotLayout, pltConfig);
    plotTC_stress.on("plotly_relayout", function (eventdata) {
      ZoomCallback(
        ["plotElement", "plotTC_strain", "plotTC_u", "plotTC_tau"],
        ["y", "y", "y", "y"],
        [eventdata["xaxis.range[0]"], eventdata["xaxis.range[1]"]],
        [eventdata["yaxis.range[0]"], eventdata["yaxis.range[1]"]]
      );
    });
    plotTC_stress.on("plotly_doubleclick", function () {
      doubleClick_event();
    });

    // TC Strain
    alertmsg = [
      "Fliessgrenze des Stahls",
      "Mittlere Stahldehnung",
      "Mittlere Betondehnung",
    ];
    if (lang == "en") {
      alertmsg = [
        "Yield strength of the steel",
        "Mean steel strain",
        "Mean concrete strain",
      ];
    }

    data = {
      plotData: [
        {
          x: epsilon_steel_plot[0].x,
          y: epsilon_steel_plot[0].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
        },
        {
          x: epsilon_steel_plot[1].x,
          y: epsilon_steel_plot[1].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
        },
        {
          x: epsilon_steel_plot[0].x,
          y: epsilon_steel_plot[0].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: blue9,
          name: "",
          hovertemplate: "ε<sub><i>s</i></sub> = %{x:,.3f} ‰",
        },
        {
          x: epsilon_steel_plot[1].x,
          y: epsilon_steel_plot[1].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: blue9,
          name: "",
          hovertemplate: "ε<sub><i>s</i></sub> = %{x:,.3f} ‰",
        },

        {
          x: epsilon_concrete_plot[0].x,
          y: epsilon_concrete_plot[0].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
        },
        {
          x: epsilon_concrete_plot[1].x,
          y: epsilon_concrete_plot[1].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
        },

        {
          x: epsilon_concrete_plot[0].x,
          y: epsilon_concrete_plot[0].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: green9,
          name: "",
          hovertemplate: "ε<sub><i>c</i></sub> = %{x:,.3f} ‰",
        },
        {
          x: epsilon_concrete_plot[1].x,
          y: epsilon_concrete_plot[1].y,

          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: green9,
          name: "",
          hovertemplate: "ε<sub><i>s</i></sub> = %{x:,.3f} ‰",
        },
        {
          x: [esy * 1000, esy * 1000],
          y: [-2 * srm, 2 * srm],
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "dot",
            width: 1,
            color: "rgb(150,150,255)",
          },
          showlegend: true,
          name: alertmsg[0],
        },
        {
          x: math.dotMultiply(math.ones(1000), esm_marker)[0],
          y: math.range(-2 * srm, 2 * srm, srm / 1000)._data,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "dash",
            width: 1,
            color: "rgb(150,150,255)",
          },
          showlegend: true,
          name: alertmsg[1],
          hovertemplate: "ε<sub><i>sm</i></sub> = %{x:,.3f} ‰",
        },
        {
          x: math.dotMultiply(math.ones(1000), ecm_marker)[0],
          y: math.range(-1000, 1000, 2)._data,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "dash",
            width: 1,
            color: "rgb(150,255,150)",
          },
          showlegend: true,
          name: alertmsg[2],
          hovertemplate: "ε<sub><i>cm</i></sub> = %{x:,.3f} ‰",
        },
      ],
      plotLayout: {
        hovermode: "closest",
        height: he,
        margin: {
          l: 0,
          r: 15,
          b: 50,
          t: 50,
          pad: 0,
        },

        yaxis: {
          domain: [0, 1],
          range: [range_y_init[0], range_y_init[1]],
          ticks: "",
          showticklabels: false,
        },

        xaxis1: {
          title: "ε<sub><i>s</i></sub> [‰]",
          titlefont: {
            color: "rgb(0,0,200)",
          },
          tickfont: {
            color: "rgb(0,0,200)",
          },
          domain: [domain_l, domain_r],
          rangemode: "tozero",
          range: [range_eps_s_init[0], range_eps_s_init[1]],
        },
        xaxis2: {
          title: "ε<sub><i>c</i></sub> [‰]",
          titlefont: {
            color: "rgb(0,200,0)",
          },
          tickfont: {
            color: "rgb(0,200,0)",
          },
          overlaying: "x1",
          side: "top",
          domain: [domain_l, domain_r],
          rangemode: "tozero",
          range: [range_eps_c_init[0], range_eps_c_init[1]],
        },
        showlegend: true,
        legend: {
          xanchor: "center",
          x: 0.5,
          y: 1,
        },
      },
    };

    if (window.checkMobile() == true) {
      data.plotLayout.dragmode = false;
    }
    Plotly.newPlot("plotTC_strain", data.plotData, data.plotLayout, pltConfig);

    plotTC_strain.on("plotly_relayout", function (eventdata) {
      ZoomCallback(
        ["plotElement", "plotTC_stress", "plotTC_u", "plotTC_tau"],
        ["y", "y", "y", "y"],
        [eventdata["xaxis.range[0]"], eventdata["xaxis.range[1]"]],
        [eventdata["yaxis.range[0]"], eventdata["yaxis.range[1]"]]
      );
    });
    plotTC_strain.on("plotly_doubleclick", function () {
      doubleClick_event();
    });

    data = {
      plotData: [
        {
          x: u_steel_plot[0].x,
          y: u_steel_plot[0].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
        },
        {
          x: u_steel_plot[1].x,
          y: u_steel_plot[1].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
        },
        {
          x: u_steel_plot[0].x,
          y: u_steel_plot[0].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: blue9,
          name: "",
          hovertemplate: "u<sub><i>s</i></sub> = %{x:,.3f} mm",
        },
        {
          x: u_steel_plot[1].x,
          y: u_steel_plot[1].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,0,255)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: blue9,
          name: "",
          hovertemplate: "u<sub><i>s</i></sub> = %{x:,.3f} mm",
        },
        {
          x: u_concrete_plot[0].x,
          y: u_concrete_plot[0].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
        },
        {
          x: u_concrete_plot[1].x,
          y: u_concrete_plot[1].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
        },

        {
          x: u_concrete_plot[0].x,
          y: u_concrete_plot[0].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: green9,
          name: "",
          hovertemplate: "u<sub><i>c</i></sub> = %{x:,.3f} mm",
        },
        {
          x: u_concrete_plot[1].x,
          y: u_concrete_plot[1].y,
          xaxis: "x2",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(0,255,0)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: green9,
          name: "",
          hovertemplate: "u<sub><i>c</i></sub> = %{x:,.3f} mm",
        },
      ],
      plotLayout: {
        hovermode: "closest",
        height: he,
        margin: {
          l: 0,
          r: 15,
          b: 50,
          t: 50,
          pad: 0,
        },

        yaxis: {
          domain: [0, 1],

          range: [range_y_init[0], range_y_init[1]],
          ticks: "",
          showticklabels: false,
        },
        xaxis1: {
          title: "u<sub><i>s</i></sub> [mm]",
          titlefont: {
            color: "rgb(0,0,200)",
          },
          tickfont: {
            color: "rgb(0,0,200)",
          },
          domain: [domain_l, domain_r],
          range: [range_u_s_init[0], range_u_s_init[1]],
        },
        xaxis2: {
          title: "u<sub><i>c</i></sub> [mm]",
          titlefont: {
            color: "rgb(0,200,0)",
          },
          tickfont: {
            color: "rgb(0,200,0)",
          },
          overlaying: "x1",
          side: "top",
          domain: [domain_l, domain_r],
          range: [range_u_c_init[0], range_u_c_init[1]],
        },
        showlegend: true,
        legend: {
          x: 1,
          y: 0.5,
        },
      },
    };
    if (window.checkMobile() == true) {
      data.plotLayout.dragmode = false;
    }
    Plotly.newPlot("plotTC_u", data.plotData, data.plotLayout, pltConfig);

    plotTC_u.on("plotly_relayout", function (eventdata) {
      ZoomCallback(
        ["plotElement", "plotTC_stress", "plotTC_strain", "plotTC_tau"],
        ["y", "y", "y", "y"],
        [eventdata["xaxis.range[0]"], eventdata["xaxis.range[1]"]],
        [eventdata["yaxis.range[0]"], eventdata["yaxis.range[1]"]]
      );
    });
    plotTC_u.on("plotly_doubleclick", function () {
      doubleClick_event();
    });

    // TC tau
    data = {
      plotData: [
        {
          x: tau_b_plot[0].x,
          y: tau_b_plot[0].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(255,127,36)",
          },
          showlegend: false,
        },
        {
          x: tau_b_plot[1].x,
          y: tau_b_plot[1].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(255,127,36)",
          },
          showlegend: false,
        },
        {
          x: tau_b_plot[0].x,
          y: tau_b_plot[0].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(255,127,36)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: "rgba(255,210,130,0.5)",
          name: "",
          hovertemplate: "τ<sub><i>b</i></sub> = %{x:,.2f} MPa",
        },
        {
          x: tau_b_plot[1].x,
          y: tau_b_plot[1].y,
          xaxis: "x1",
          type: "scatter",
          mode: "lines",
          line: {
            dash: "solid",
            width: 1,
            color: "rgb(255,127,36)",
          },
          showlegend: false,
          fill: "tozerox",
          fillcolor: "rgba(255,210,130,0.5)",
          name: "",
          hovertemplate: "τ<sub><i>b</i></sub> = %{x:,.2f} MPa",
        },
      ],
      plotLayout: {
        hovermode: "closest",
        height: he,
        margin: {
          l: 0,
          r: 15,
          b: 50,
          t: 50,
          pad: 0,
        },

        yaxis: {
          //title: 'N [N]',
          domain: [0, 1],
          //rangemode: 'tozero',
          //autorange: true,
          range: [range_y_init[0], range_y_init[1]],
          ticks: "",
          showticklabels: false,
        },

        xaxis1: {
          title: "τ<sub><i>b</i></sub> [MPa]",
          domain: [domain_l, domain_r],
          range: [range_tau_init[0], range_tau_init[1]],
        },

        // grid: {
        //     rows: 1,
        //     columns: 5,
        //     subplots:[['xy','x2y2',x]],
        // },
        showlegend: true,
        legend: {
          x: 1,
          y: 0.5,
        },
      },
    };
    if (window.checkMobile() == true) {
      data.plotLayout.dragmode = false;
    }
    Plotly.newPlot("plotTC_tau", data.plotData, data.plotLayout, pltConfig);

    plotTC_tau.on("plotly_relayout", function (eventdata) {
      ZoomCallback(
        ["plotElement", "plotTC_stress", "plotTC_strain", "plotTC_u"],
        ["y", "y", "y", "y"],
        [eventdata["xaxis.range[0]"], eventdata["xaxis.range[1]"]],
        [eventdata["yaxis.range[0]"], eventdata["yaxis.range[1]"]]
      );
    });
    plotTC_tau.on("plotly_doubleclick", function () {
      doubleClick_event();
    });
  } else {
    Plotly.restyle("plotNwr", {
      x: [
        w_r._data,
        w_r_woc._data,
        [w_r._data[w_r._data.length - 1]],
        [w_r_woc._data[w_r_woc._data.length - 1]],
        [w_r_marker],
      ],
      y: [
        math.dotDivide(N._data, 1000),
        math.dotDivide(N._data, 1000),
        math.dotDivide([fsu * As], 1000),
        math.dotDivide([fsu * As], 1000),
        math.dotDivide([N_marker], 1000),
      ],
    });

    Plotly.restyle("plotNepsilon", {
      x: [
        [0, esy * 1000, esu * 1000],
        esm._data,
        [esm._data[esm._data.length - 1]],
        [esu * 1000],
        [esm_marker],
      ],
      y: [
        math.dotDivide([0, fsy * As, fsu * As], 1000),
        math.dotDivide(N._data, 1000),
        math.dotDivide([fsu * As], 1000),
        math.dotDivide([fsu * As], 1000),
        math.dotDivide([N_marker], 1000),
      ],
    });

    let pltSec = tempSec.getPlotData();
    var data = pltSec.data;

    Plotly.restyle("plotElement", {
      x: [
        data[0].x,
        data[1].x,
        data[2].x,
        data[3].x,
        data[4].x,
        data[5].x,
        data[6].x,
        data[7].x,
        data[8].x,
      ],
      y: [
        data[0].y,
        data[1].y,
        math.add(
          math.dotMultiply(
            math.subtract(data[2].y, math.mean(data[2].y)),
            (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
              (range_y_default[1] - range_y_default[0])
          ),
          math.mean(data[2].y)
        ),
        math.add(
          math.dotMultiply(
            math.subtract(data[3].y, math.mean(data[3].y)),
            (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
              (range_y_default[1] - range_y_default[0])
          ),
          math.mean(data[3].y)
        ),
        math.add(
          math.dotMultiply(
            math.subtract(data[4].y, math.mean(data[4].y)),
            (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
              (range_y_default[1] - range_y_default[0])
          ),
          math.mean(data[4].y)
        ),
        math.add(
          math.dotMultiply(
            math.subtract(data[5].y, math.mean(data[5].y)),
            (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
              (range_y_default[1] - range_y_default[0])
          ),
          math.mean(data[5].y)
        ),
        data[6].y,
        math.add(
          math.dotMultiply(
            math.subtract(
              data[7].y,
              (math.max(data[7].y) + math.min(data[7].y)) / 2
            ),
            (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
              (range_y_default[1] - range_y_default[0])
          ),
          ((math.max(data[7].y) - math.min(data[7].y)) / 2 + gap) *
            ((currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
              (range_y_default[1] - range_y_default[0])) +
            (wr_magnification * w_r_marker + srm)
        ),
        math.add(
          math.dotMultiply(
            math.subtract(
              data[8].y,
              (math.max(data[8].y) + math.min(data[8].y)) / 2
            ),
            (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
              (range_y_default[1] - range_y_default[0])
          ),
          -((math.max(data[8].y) - math.min(data[8].y)) / 2 + gap) *
            ((currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
              (range_y_default[1] - range_y_default[0])) -
            (wr_magnification * w_r_marker + srm)
        ),
      ],
    });

    Plotly.restyle("plotTC_stress", {
      x: [
        sigma_steel_plot[0].x,
        sigma_steel_plot[1].x,
        sigma_steel_plot[0].x,
        sigma_steel_plot[1].x,
        [fsy, fsy],
        sigma_concrete_plot[0].x,
        sigma_concrete_plot[1].x,
        sigma_concrete_plot[0].x,
        sigma_concrete_plot[1].x,
      ],
      y: [
        sigma_steel_plot[0].y,
        sigma_steel_plot[1].y,
        sigma_steel_plot[0].y,
        sigma_steel_plot[1].y,
        [-2 * srm, 2 * srm],
        sigma_concrete_plot[0].y,
        sigma_concrete_plot[1].y,
        sigma_concrete_plot[0].y,
        sigma_concrete_plot[1].y,
      ],
    });

    Plotly.restyle("plotTC_strain", {
      x: [
        epsilon_steel_plot[0].x,
        epsilon_steel_plot[1].x,
        epsilon_steel_plot[0].x,
        epsilon_steel_plot[1].x,
        epsilon_concrete_plot[0].x,
        epsilon_concrete_plot[1].x,
        epsilon_concrete_plot[0].x,
        epsilon_concrete_plot[1].x,
        [esy * 1000, esy * 1000],
        math.dotMultiply([math.ones(1000)], esm_marker)[0],
        math.dotMultiply([math.ones(1000)], ecm_marker)[0],
      ],
      y: [
        epsilon_steel_plot[0].y,
        epsilon_steel_plot[1].y,
        epsilon_steel_plot[0].y,
        epsilon_steel_plot[1].y,
        epsilon_concrete_plot[0].y,
        epsilon_concrete_plot[1].y,
        epsilon_concrete_plot[0].y,
        epsilon_concrete_plot[1].y,
        [-2 * srm, 2 * srm],
        math.range(-2 * srm, 2 * srm, (4 * srm) / 1000)._data,
        math.range(-2 * srm, 2 * srm, (4 * srm) / 1000)._data,
      ],
    });

    Plotly.restyle("plotTC_u", {
      x: [
        u_steel_plot[0].x,
        u_steel_plot[1].x,
        u_steel_plot[0].x,
        u_steel_plot[1].x,
        u_concrete_plot[0].x,
        u_concrete_plot[1].x,
        u_concrete_plot[0].x,
        u_concrete_plot[1].x,
      ],
      y: [
        u_steel_plot[0].y,
        u_steel_plot[1].y,
        u_steel_plot[0].y,
        u_steel_plot[1].y,
        u_concrete_plot[0].y,
        u_concrete_plot[1].y,
        u_concrete_plot[0].y,
        u_concrete_plot[1].y,
      ],
    });

    Plotly.restyle("plotTC_tau", {
      x: [tau_b_plot[0].x, tau_b_plot[1].x, tau_b_plot[0].x, tau_b_plot[1].x],
      y: [tau_b_plot[0].y, tau_b_plot[1].y, tau_b_plot[0].y, tau_b_plot[1].y],
    });
  }
}

function f_esm(
  sigma_sr,
  fsy,
  Es,
  fsu,
  Esh,
  esy,
  taub0,
  taub1,
  srm,
  D,
  Ec,
  fct,
  rho
) {
  var esm_i;
  var sigma_sr0 = (fct / rho) * (1 + rho * (Es / Ec - 1));
  sigma_sr = math.round(sigma_sr * 1000) / 1000;
  if (sigma_sr < sigma_sr0) {
    esm_i = (sigma_sr * rho) / (Ec * (1 + (Es / Ec - 1) * rho));
  } else {
    if (sigma_sr < fsy) {
      esm_i = sigma_sr / Es - (taub0 * srm) / (Es * D);
    } else {
      if (sigma_sr < fsy + (2 * taub1 * srm) / D) {
        esm_i =
          ((math.pow(sigma_sr - fsy, 2) * D) / (4 * Esh * taub1 * srm)) *
            (1 - (Esh * taub0) / (Es * taub1)) +
          (((sigma_sr - fsy) / Es) * taub0) / taub1 +
          (esy - (taub0 * srm) / (Es * D));
      } else {
        esm_i = (sigma_sr - fsy) / Esh + (esy - (taub1 * srm) / (Esh * D));
      }
    }
  }
  let esm_i1000 = esm_i * 1000;
  return esm_i1000;
}

function f_wr(
  sigma_sr,
  fsy,
  Es,
  fsu,
  Esh,
  esy,
  taub0,
  taub1,
  srm,
  D,
  Ec,
  fct,
  rho
) {
  var u_s;
  var u_c;

  var sigma_s, epsilon_s, sigma_c, epsilon_c, y, yel, ypl;
  var sigma_sr0 = (fct / rho) * (1 + rho * (Es / Ec - 1));
  var u_s_el, u_s_pl;
  if (sigma_sr < fsy) {
    var sigma_s_centre = sigma_sr - (((4 * taub0) / D) * srm) / 2;
    var sigma_c_centre = (((((4 * taub0) / D) * srm) / 2) * rho) / (1 - rho);

    u_s =
      (sigma_s_centre * (srm / 2) +
        (((4 * taub0) / D) * (srm / 2) * math.abs(srm / 2)) / 2) /
      Es;
    u_c =
      (sigma_c_centre * (srm / 2) -
        (((((4 * taub0) / D) * rho) / (1 - rho)) *
          (srm / 2) *
          math.abs(srm / 2)) /
          2) /
      Ec;
  } else {
    if (sigma_sr < fsy + (2 * taub1 * srm) / D) {
      ypl = ((sigma_sr - fsy) * D) / (4 * taub1);
      yel = srm / 2 - ypl;
      sigma_s = [sigma_sr, fsy, fsy - (yel * 4 * taub0) / D, fsy, sigma_sr];
      epsilon_s = [
        (sigma_sr - fsy) / Esh + fsy / Es,
        fsy / Es,
        (fsy - (yel * 4 * taub0) / D) / Es,
        fsy / Es,
        (sigma_sr - fsy) / Esh + fsy / Es,
      ];
      sigma_c = [
        0,
        (((4 * taub1) / D) * ypl * rho) / (1 - rho),
        ((((4 * taub1) / D) * ypl + ((4 * taub0) / D) * yel) * rho) / (1 - rho),
        (((4 * taub1) / D) * ypl * rho) / (1 - rho),
        0,
      ];
      y = [0, ypl, srm / 2, srm - ypl, srm];

      var sigma_s_centre = fsy - (yel * 4 * taub0) / D;
      var sigma_c_centre =
        ((((4 * taub0) / D) * yel + ((4 * taub1) / D) * ypl) * rho) / (1 - rho);
      var sigma_c_yield = (((4 * taub1) / D) * ypl * rho) / (1 - rho);

      if (math.abs(srm / 2) <= yel) {
        u_s =
          (sigma_s_centre * (srm / 2) +
            ((4 * taub0) / D) * (srm / 2) * math.abs(srm / 2 / 2)) /
          Es;
        u_c =
          (sigma_c_centre * (srm / 2) -
            (((((4 * taub0) / D) * rho) / (1 - rho)) *
              (srm / 2) *
              math.abs(srm / 2)) /
              2) /
          Ec;
      } else {
        u_s_el =
          (math.sign(srm / 2) *
            (sigma_s_centre * yel +
              math.max(ypl - srm, srm / 2 - yel) * fsy +
              (((4 * taub0) / D) * yel * yel) / 2)) /
          Es;
        u_s_pl =
          (((math.sign(srm / 2) * 4 * taub1) / D) *
            math.max(ypl - srm, srm / 2 - yel) *
            math.max(ypl - srm, srm / 2 - yel)) /
          2 /
          Esh;
        u_s = u_s_el + u_s_pl;

        var sigma_c_i =
          (((math.min(srm, srm - srm) * 4 * taub1) / D) * rho) / (1 - rho);
        u_c =
          (math.sign(srm / 2) *
            (((ypl - math.min(srm, srm - srm)) * (sigma_c_yield + sigma_c_i)) /
              2 +
              (yel * (sigma_c_centre + sigma_c_yield)) / 2)) /
          Ec;
      }
    } else {
      sigma_s = [sigma_sr, sigma_sr - (((4 * taub1) / D) * srm) / 2, sigma_sr];
      epsilon_s = math.add(
        math.dotDivide(
          math.subtract(
            [sigma_sr, sigma_sr - (((4 * taub1) / D) * srm) / 2, sigma_sr],
            fsy
          ),
          Esh
        ),
        fsy / Es
      );
      sigma_c = [0, (((((4 * taub1) / D) * srm) / 2) * rho) / (1 - rho), 0];
      y = [0, srm / 2, srm];

      var sigma_s_centre = sigma_sr - (((4 * taub1) / D) * srm) / 2;

      u_s_el = (fsy * (srm / 2)) / Es;
      u_s_pl =
        ((sigma_s_centre - fsy) * (srm / 2) +
          ((4 * taub1) / D) * (srm / 2) * math.abs(srm / 2 / 2)) /
        Esh;
      u_s = u_s_el + u_s_pl;

      var sigma_c_i =
        (((math.min(srm, srm - srm) * 4 * taub1) / D) * rho) / (1 - rho);
      var sigma_c_centre = (((((4 * taub1) / D) * srm) / 2) * rho) / (1 - rho);
      u_c = ((srm / 2) * (sigma_c_i + sigma_c_centre)) / 2 / Ec;
    }
  }
  if (sigma_sr < sigma_sr0) {
    u_s = 0;
    u_c = 0;
  }

  var output = [u_s, u_c];
  return output;
}

function InnerTC(
  sigma_sr,
  fsy,
  Es,
  fsu,
  Esh,
  esy,
  taub0,
  taub1,
  srm,
  D,
  Ec,
  fct,
  rho
) {
  var sigma_s, epsilon_s, sigma_c, epsilon_c, y, yel, ypl;
  var sigma_sr0 = (fct / rho) * (1 + rho * (Es / Ec - 1));
  var u_s_el, u_s_pl;
  var x_tau, y_tau;

  var i;
  var u_y = math.range(0, srm, (srm - 0.00001) / 100, true);
  var u_s = math.zeros(u_y.size()[0]);
  var u_c = math.zeros(u_y.size()[0]);

  if (sigma_sr < fsy) {
    sigma_s = [sigma_sr, sigma_sr - (((4 * taub0) / D) * srm) / 2, sigma_sr];
    epsilon_s = [
      sigma_sr / Es,
      (sigma_sr - (((4 * taub0) / D) * srm) / 2) / Es,
      sigma_sr / Es,
    ];
    sigma_c = [0, (((((4 * taub0) / D) * srm) / 2) * rho) / (1 - rho), 0];
    y = [0, srm / 2, srm];

    var sigma_s_centre = sigma_sr - (((4 * taub0) / D) * srm) / 2;
    var sigma_c_centre = (((((4 * taub0) / D) * srm) / 2) * rho) / (1 - rho);
    for (i = 0; i < u_y._data.length; i++) {
      u_s._data[i] =
        (sigma_s_centre * (u_y._data[i] - srm / 2) +
          (((4 * taub0) / D) *
            (u_y._data[i] - srm / 2) *
            math.abs(u_y._data[i] - srm / 2)) /
            2) /
        Es;
      u_c._data[i] =
        (sigma_c_centre * (u_y._data[i] - srm / 2) -
          (((((4 * taub0) / D) * rho) / (1 - rho)) *
            (u_y._data[i] - srm / 2) *
            math.abs(u_y._data[i] - srm / 2)) /
            2) /
        Ec;
    }

    x_tau = [-taub0, -taub0, taub0, taub0];
    y_tau = [0, srm / 2, srm / 2, srm];
  } else {
    if (sigma_sr < fsy + (2 * taub1 * srm) / D) {
      ypl = ((sigma_sr - fsy) * D) / (4 * taub1);
      yel = srm / 2 - ypl;
      sigma_s = [sigma_sr, fsy, fsy - (yel * 4 * taub0) / D, fsy, sigma_sr];
      epsilon_s = [
        (sigma_sr - fsy) / Esh + fsy / Es,
        fsy / Es,
        (fsy - (yel * 4 * taub0) / D) / Es,
        fsy / Es,
        (sigma_sr - fsy) / Esh + fsy / Es,
      ];
      sigma_c = [
        0,
        (((4 * taub1) / D) * ypl * rho) / (1 - rho),
        ((((4 * taub1) / D) * ypl + ((4 * taub0) / D) * yel) * rho) / (1 - rho),
        (((4 * taub1) / D) * ypl * rho) / (1 - rho),
        0,
      ];
      y = [0, ypl, srm / 2, srm - ypl, srm];

      var sigma_s_centre = fsy - (yel * 4 * taub0) / D;
      var sigma_c_centre =
        ((((4 * taub0) / D) * yel + ((4 * taub1) / D) * ypl) * rho) / (1 - rho);
      var sigma_c_yield = (((4 * taub1) / D) * ypl * rho) / (1 - rho);
      for (i = 0; i < u_y._data.length; i++) {
        if (math.abs(u_y._data[i] - srm / 2) <= yel) {
          u_s._data[i] =
            (sigma_s_centre * (u_y._data[i] - srm / 2) +
              ((4 * taub0) / D) *
                (u_y._data[i] - srm / 2) *
                math.abs((u_y._data[i] - srm / 2) / 2)) /
            Es;
          u_c._data[i] =
            (sigma_c_centre * (u_y._data[i] - srm / 2) -
              (((((4 * taub0) / D) * rho) / (1 - rho)) *
                (u_y._data[i] - srm / 2) *
                math.abs(u_y._data[i] - srm / 2)) /
                2) /
            Ec;
        } else {
          u_s_el =
            (math.sign(u_y._data[i] - srm / 2) *
              (sigma_s_centre * yel +
                math.max(ypl - u_y._data[i], u_y._data[i] - srm / 2 - yel) *
                  fsy +
                (((4 * taub0) / D) * yel * yel) / 2)) /
            Es;
          u_s_pl =
            (((math.sign(u_y._data[i] - srm / 2) * 4 * taub1) / D) *
              math.max(ypl - u_y._data[i], u_y._data[i] - srm / 2 - yel) *
              math.max(ypl - u_y._data[i], u_y._data[i] - srm / 2 - yel)) /
            2 /
            Esh;
          u_s._data[i] = u_s_el + u_s_pl;

          var sigma_c_i =
            (((math.min(u_y._data[i], srm - u_y._data[i]) * 4 * taub1) / D) *
              rho) /
            (1 - rho);
          u_c._data[i] =
            (math.sign(u_y._data[i] - srm / 2) *
              (((ypl - math.min(u_y._data[i], srm - u_y._data[i])) *
                (sigma_c_yield + sigma_c_i)) /
                2 +
                (yel * (sigma_c_centre + sigma_c_yield)) / 2)) /
            Ec;
        }
      }

      x_tau = [-taub1, -taub1, -taub0, -taub0, taub0, taub0, taub1, taub1];
      y_tau = [0, ypl, ypl, srm / 2, srm / 2, srm - ypl, srm - ypl, srm];
    } else {
      sigma_s = [sigma_sr, sigma_sr - (((4 * taub1) / D) * srm) / 2, sigma_sr];
      epsilon_s = math.add(
        math.dotDivide(
          math.subtract(
            [sigma_sr, sigma_sr - (((4 * taub1) / D) * srm) / 2, sigma_sr],
            fsy
          ),
          Esh
        ),
        fsy / Es
      );
      sigma_c = [0, (((((4 * taub1) / D) * srm) / 2) * rho) / (1 - rho), 0];
      y = [0, srm / 2, srm];

      var sigma_s_centre = sigma_sr - (((4 * taub1) / D) * srm) / 2;
      for (i = 0; i < u_y._data.length; i++) {
        u_s_el = (fsy * (u_y._data[i] - srm / 2)) / Es;
        u_s_pl =
          ((sigma_s_centre - fsy) * (u_y._data[i] - srm / 2) +
            ((4 * taub1) / D) *
              (u_y._data[i] - srm / 2) *
              math.abs((u_y._data[i] - srm / 2) / 2)) /
          Esh;
        u_s._data[i] = u_s_el + u_s_pl;

        var sigma_c_i =
          (((math.min(u_y._data[i], srm - u_y._data[i]) * 4 * taub1) / D) *
            rho) /
          (1 - rho);
        var sigma_c_centre =
          (((((4 * taub1) / D) * srm) / 2) * rho) / (1 - rho);
        u_c._data[i] =
          ((u_y._data[i] - srm / 2) * (sigma_c_i + sigma_c_centre)) / 2 / Ec;
      }
      x_tau = [-taub1, -taub1, taub1, taub1];
      y_tau = [0, srm / 2, srm / 2, srm];
    }
  }
  if (sigma_sr < sigma_sr0) {
    var sc = (sigma_sr * rho) / (1 + (Es / Ec) * rho - rho);
    sigma_s = [(sc * Es) / Ec, (sc * Es) / Ec, (sc * Es) / Ec];
    sigma_c = [sc, sc, sc];
    epsilon_s = math.dotMultiply(sc / Ec, [1, 1, 1]);
    y = [0, srm / 2, srm];
    for (i = 0; i < u_y._data.length; i++) {
      u_s._data[i] = (i / u_y._data.length) * ((sc / Ec) * srm);
    }
    //u_s = math.zeros(u_y.size()[0]);
    u_c = u_s;
    x_tau = [0, 0];
    y_tau = [0, srm];
  }
  var output = [
    // sigma_s
    {
      x: sigma_s,
      y: y,
    },
    // sigma_c
    {
      x: sigma_c,
      y: y,
    },
    // epsilon_s
    {
      x: math.dotMultiply(epsilon_s, 1000),
      y: y,
    },
    // epsilon_c
    {
      x: math.dotMultiply(math.dotDivide(sigma_c, Ec), 1000),
      y: y,
    },
    // u_s
    {
      x: u_s,
      y: u_y,
    },
    // u_c
    {
      x: u_c,
      y: u_y,
    },
    // tau_b
    {
      x: x_tau,
      y: y_tau,
    },
  ];

  return output;
}

function ZoomCallback(plotstoupdate, axes, xRangeNew, yRangeNew) {
  //var gd=document.getElementById(plotstoupdate[0]);
  for (i = 0; i < plotstoupdate.length; i++) {
    //var gd=document.getElementById(plotstoupdate[i]);

    if (typeof yRangeNew[0] !== "undefined") {
      if (axes[i] == "y") {
        Plotly.relayout(plotstoupdate[i], { "yaxis.range": yRangeNew });
      }
      if (axes[i] == "x") {
        Plotly.relayout(plotstoupdate[i], { "xaxis.range": xRangeNew });
      }

      if (axes[i] == "xy") {
        Plotly.relayout(plotstoupdate[i], {
          "xaxis.range": xRangeNew,
          "yaxis.range": yRangeNew,
        });
      }

      currentyRangeTCElement = yRangeNew;
      let pltSec = tempSec.getPlotData();
      var data = pltSec.data;

      Plotly.restyle("plotElement", {
        x: [
          data[0].x,
          data[1].x,
          data[2].x,
          data[3].x,
          data[4].x,
          data[5].x,
          data[6].x,
          data[7].x,
          data[8].x,
        ],
        y: [
          data[0].y,
          data[1].y,
          math.add(
            math.dotMultiply(
              math.subtract(data[2].y, math.mean(data[2].y)),
              (yRangeNew[1] - yRangeNew[0]) /
                (range_y_default[1] - range_y_default[0])
            ),
            math.mean(data[2].y)
          ),
          math.add(
            math.dotMultiply(
              math.subtract(data[3].y, math.mean(data[3].y)),
              (yRangeNew[1] - yRangeNew[0]) /
                (range_y_default[1] - range_y_default[0])
            ),
            math.mean(data[3].y)
          ),
          math.add(
            math.dotMultiply(
              math.subtract(data[4].y, math.mean(data[4].y)),
              (yRangeNew[1] - yRangeNew[0]) /
                (range_y_default[1] - range_y_default[0])
            ),
            math.mean(data[4].y)
          ),
          math.add(
            math.dotMultiply(
              math.subtract(data[5].y, math.mean(data[5].y)),
              (yRangeNew[1] - yRangeNew[0]) /
                (range_y_default[1] - range_y_default[0])
            ),
            math.mean(data[5].y)
          ),
          data[6].y,
          math.add(
            math.dotMultiply(
              math.subtract(
                data[7].y,
                (math.max(data[7].y) + math.min(data[7].y)) / 2
              ),
              (yRangeNew[1] - yRangeNew[0]) /
                (range_y_default[1] - range_y_default[0])
            ),
            ((math.max(data[7].y) - math.min(data[7].y)) / 2 + gap) *
              ((yRangeNew[1] - yRangeNew[0]) /
                (range_y_default[1] - range_y_default[0])) +
              wr_magnification * w_r_marker +
              srm
          ),
          math.add(
            math.dotMultiply(
              math.subtract(
                data[8].y,
                (math.max(data[8].y) + math.min(data[8].y)) / 2
              ),
              (yRangeNew[1] - yRangeNew[0]) /
                (range_y_default[1] - range_y_default[0])
            ),
            -((math.max(data[8].y) - math.min(data[8].y)) / 2 + gap) *
              ((yRangeNew[1] - yRangeNew[0]) /
                (range_y_default[1] - range_y_default[0])) -
              wr_magnification * w_r_marker -
              srm
          ),
        ],
      });
    }
  }

  return;
}

function handlecheckboxclick() {
  var checkbox = document.getElementById("axesscale");

  var plotTC_stress = document.getElementById("plotTC_stress");
  var plotTC_strain = document.getElementById("plotTC_strain");
  var plotTC_u = document.getElementById("plotTC_u");

  if (checkbox.checked != true) {
    Plotly.relayout("plotTC_stress", {
      "xaxis2.range": [
        (range_sigma_c_init[1] / range_sigma_s_init[1]) *
          plotTC_stress.layout.xaxis.range[0],
        (range_sigma_c_init[1] / range_sigma_s_init[1]) *
          plotTC_stress.layout.xaxis.range[1],
      ],
    });

    Plotly.relayout("plotTC_strain", {
      "xaxis2.range": [
        (range_eps_c_init[1] / range_eps_s_init[1]) *
          plotTC_strain.layout.xaxis.range[0],
        (range_eps_c_init[1] / range_eps_s_init[1]) *
          plotTC_strain.layout.xaxis.range[1],
      ],
    });
    Plotly.relayout("plotTC_u", {
      "xaxis2.range": [
        (range_u_c_init[1] / range_u_s_init[1]) *
          plotTC_u.layout.xaxis.range[0],
        (range_u_c_init[1] / range_u_s_init[1]) *
          plotTC_u.layout.xaxis.range[1],
      ],
    });
  } else {
    Plotly.relayout("plotTC_stress", {
      "xaxis2.range": plotTC_stress.layout.xaxis.range,
    });
    Plotly.relayout("plotTC_strain", {
      "xaxis2.range": plotTC_strain.layout.xaxis.range,
    });
    Plotly.relayout("plotTC_u", {
      "xaxis2.range": plotTC_u.layout.xaxis.range,
    });
  }
}

function doubleClick_event() {
  var plotTC_stress = document.getElementById("plotTC_stress");
  var plotTC_strain = document.getElementById("plotTC_strain");
  var plotTC_u = document.getElementById("plotTC_u");

  var sr0 = (fct * D * (1 - rho)) / (2 * taub0 * rho);
  srm = Lambda * sr0;

  range_y_init = [-srm * 1.75, srm * 1.75];

  currentyRangeTCElement = range_y_init;
  let pltSec = tempSec.getPlotData();
  var data = pltSec.data;

  Plotly.restyle("plotElement", {
    x: [
      data[0].x,
      data[1].x,
      data[2].x,
      data[3].x,
      data[4].x,
      data[5].x,
      data[6].x,
      data[7].x,
      data[8].x,
    ],
    y: [
      data[0].y,
      data[1].y,
      math.add(
        math.dotMultiply(
          math.subtract(data[2].y, math.mean(data[2].y)),
          (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
            (range_y_default[1] - range_y_default[0])
        ),
        math.mean(data[2].y)
      ),
      math.add(
        math.dotMultiply(
          math.subtract(data[3].y, math.mean(data[3].y)),
          (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
            (range_y_default[1] - range_y_default[0])
        ),
        math.mean(data[3].y)
      ),
      math.add(
        math.dotMultiply(
          math.subtract(data[4].y, math.mean(data[4].y)),
          (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
            (range_y_default[1] - range_y_default[0])
        ),
        math.mean(data[4].y)
      ),
      math.add(
        math.dotMultiply(
          math.subtract(data[5].y, math.mean(data[5].y)),
          (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
            (range_y_default[1] - range_y_default[0])
        ),
        math.mean(data[5].y)
      ),
      data[6].y,
      math.add(
        math.dotMultiply(
          math.subtract(
            data[7].y,
            (math.max(data[7].y) + math.min(data[7].y)) / 2
          ),
          (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
            (range_y_default[1] - range_y_default[0])
        ),
        ((math.max(data[7].y) - math.min(data[7].y)) / 2 + gap) *
          ((currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
            (range_y_default[1] - range_y_default[0])) +
          wr_magnification * w_r_marker +
          srm
      ),
      math.add(
        math.dotMultiply(
          math.subtract(
            data[8].y,
            (math.max(data[8].y) + math.min(data[8].y)) / 2
          ),
          (currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
            (range_y_default[1] - range_y_default[0])
        ),
        (-(math.max(data[8].y) - math.min(data[8].y)) / 2 - gap) *
          ((currentyRangeTCElement[1] - currentyRangeTCElement[0]) /
            (range_y_default[1] - range_y_default[0])) -
          wr_magnification * w_r_marker -
          srm
      ),
    ],
  });

  var checkbox = document.getElementById("axesscale");
  if (checkbox.checked != true) {
    Plotly.relayout("plotElement", {
      "yaxis.range": [range_y_init[0], range_y_init[1]],
      //'yaxis.range': [0,0],
    });
    Plotly.relayout("plotTC_stress", {
      "xaxis.range": [range_sigma_s_init[0], range_sigma_s_init[1]],
      "xaxis2.range": [range_sigma_c_init[0], range_sigma_c_init[1]],
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
    Plotly.relayout("plotTC_strain", {
      "xaxis.range": [range_eps_s_init[0], range_eps_s_init[1]],
      "xaxis2.range": [range_eps_c_init[0], range_eps_c_init[1]],
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
    Plotly.relayout("plotTC_u", {
      "xaxis.range": [range_u_s_init[0], range_u_s_init[1]],
      "xaxis2.range": [range_u_c_init[0], range_u_c_init[1]],
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
    Plotly.relayout("plotTC_tau", {
      "xaxis.range": [range_tau_init[0], range_tau_init[1]],
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
  } else {
    Plotly.relayout("plotElement", {
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
    Plotly.relayout("plotTC_stress", {
      "xaxis.range": [range_sigma_s_init[0], range_sigma_s_init[1]],
      "xaxis2.range": [range_sigma_s_init[0], range_sigma_s_init[1]],
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
    Plotly.relayout("plotTC_strain", {
      "xaxis.range": [range_eps_s_init[0], range_eps_s_init[1]],
      "xaxis2.range": [range_eps_s_init[0], range_eps_s_init[1]],
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
    Plotly.relayout("plotTC_u", {
      "xaxis.range": [range_u_s_init[0], range_u_s_init[1]],
      "xaxis2.range": [range_u_s_init[0], range_u_s_init[1]],
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
    Plotly.relayout("plotTC_tau", {
      "xaxis.range": [range_tau_init[0], range_tau_init[1]],
      "yaxis.range": [range_y_init[0], range_y_init[1]],
    });
  }
}

function NdoubleClick_event() {
  range_esm_init = [0, esu * 1.05 * 1000];
  range_N_init = [0, (fsu * Ac * rho * 1.05) / 1000];

  var sr0 = (fct * D * (1 - rho)) / (2 * taub0 * rho);
  srm = Lambda * sr0;
  var w_r_max = f_wr(
    fsu,
    fsy,
    Es,
    fsu,
    Esh,
    esy,
    taub0,
    taub1,
    srm,
    D,
    Ec,
    fct,
    rho
  );
  range_wr_init = [0, 2 * w_r_max[0] * 1.05];

  Plotly.relayout("plotNepsilon", {
    "xaxis.range": range_esm_init,
    "yaxis.range": range_N_init,
  });
  Plotly.relayout("plotNwr", {
    "xaxis.range": range_wr_init,
    "yaxis.range": range_N_init,
  });
}

updateCalc();
